var map = {
	"./acc.png": 3377,
	"./aditya.png": 2098,
	"./ambuja.png": 7998,
	"./aryan.png": 7641,
	"./bhavani.png": 7869,
	"./bhel.png": 5637,
	"./bpsl.png": 2391,
	"./facor.png": 6023,
	"./flsmidth.png": 7281,
	"./gannon.png": 8039,
	"./hindalco.png": 5930,
	"./jsl.png": 3209,
	"./jspl.png": 5885,
	"./lt.png": 9864,
	"./macawber.png": 1264,
	"./mecgale.png": 9974,
	"./ntpc.png": 4833,
	"./opgc.png": 2427,
	"./power-max.png": 3456,
	"./spiegel.png": 7595,
	"./vedanta.png": 7047
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9686;